/**
 * Models generated from "Model and Storage" and models extracted from services.
 * To generate entity use syntax:
 * Apperyio.EntityAPI("<model_name>[.<model_field>]");
 */
export var models = {
    "User": {
        "type": "object",
        "properties": {
            "phone": {
                "type": "object",
                "properties": {
                    "country": {
                        "type": "string"
                    },
                    "phone_number": {
                        "type": "string"
                    }
                }
            },
            "username": {
                "type": "string"
            },
            "token": {
                "type": "string"
            },
            "auth": {
                "type": "boolean"
            },
            "personal": {
                "type": "object",
                "properties": {
                    "FirstName": {
                        "type": "string"
                    },
                    "DOB": {
                        "type": "string"
                    },
                    "Gender": {
                        "type": "string"
                    },
                    "LastName": {
                        "type": "string"
                    },
                    "Photo": {
                        "type": "any"
                    },
                    "Address": {
                        "type": "Address"
                    }
                }
            },
            "_id": {
                "type": "number"
            },
            "collections": {
                "type": "any"
            },
            "expire": {
                "type": "string"
            },
            "email": {
                "type": "string"
            },
            "future_trips": {
                "type": "Trip_List"
            },
            "past_trips": {
                "type": "Trip_List"
            }
        }
    },
    "Place_List": {
        "type": "array",
        "items": [{
            "type": "Place_Item"
        }]
    },
    "mapMarker": {
        "type": "object",
        "properties": {
            "coordinates": {
                "type": "object",
                "properties": {
                    "latitude": {
                        "type": "number"
                    },
                    "longitude": {
                        "type": "number"
                    }
                }
            },
            "iconUrl": {
                "type": "object",
                "properties": {
                    "scaledSize": {
                        "type": "object",
                        "properties": {
                            "width": {
                                "type": "number"
                            },
                            "height": {
                                "type": "number"
                            }
                        }
                    },
                    "url": {
                        "type": "string"
                    }
                }
            },
            "place_id": {
                "type": "any"
            }
        }
    },
    "coordinates": {
        "type": "object",
        "properties": {
            "longitude": {
                "type": "number"
            },
            "latitude": {
                "type": "number"
            }
        }
    },
    "Season_Factors": {
        "type": "object",
        "properties": {
            "events": {
                "type": "array",
                "items": [{
                    "type": "Event"
                }]
            },
            "weather": {
                "type": "object",
                "properties": {
                    "score": {
                        "type": "number"
                    }
                }
            },
            "holidays": {
                "type": "array",
                "items": [{
                    "type": "Event"
                }]
            },
            "score": {
                "type": "number"
            }
        }
    },
    "Trip_List": {
        "type": "array",
        "items": [{
            "type": "Trip_Item"
        }]
    },
    "String": {
        "type": "string"
    },
    "Country_Info": {
        "type": "object",
        "properties": {
            "flagClass": {
                "type": "any"
            },
            "name": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "sovereignty": {
                "type": "string"
            },
            "isoCode": {
                "type": "string"
            },
            "dialCode": {
                "type": "string"
            }
        }
    },
    "pass_item": {
        "type": "object",
        "properties": {
            "code": {
                "type": "any"
            },
            "duration": {
                "type": "object",
                "properties": {
                    "start": {
                        "type": "any"
                    },
                    "end": {
                        "type": "any"
                    }
                }
            },
            "image": {
                "type": "any"
            },
            "confirm": {
                "type": "object",
                "properties": {
                    "start": {
                        "type": "boolean"
                    },
                    "end": {
                        "type": "boolean"
                    },
                    "duration": {
                        "type": "boolean"
                    }
                }
            }
        }
    },
    "Number": {
        "type": "number"
    },
    "Address": {
        "type": "object",
        "properties": {
            "country": {
                "type": "string"
            },
            "state_province": {
                "type": "string"
            },
            "city": {
                "type": "string"
            },
            "street": {
                "type": "string"
            },
            "post_code": {
                "type": "string"
            }
        }
    },
    "Metrics": {
        "type": "object",
        "properties": {
            "temperature": {
                "type": "string"
            }
        }
    },
    "Trip_Item": {
        "type": "object",
        "properties": {
            "name": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "category": {
                "type": "number"
            },
            "daylist": {
                "type": "array",
                "items": [{
                    "type": "object",
                    "properties": {
                        "weather": {
                            "type": "weather"
                        },
                        "summary": {
                            "type": "string"
                        },
                        "itemlist": {
                            "type": "array",
                            "items": [{
                                "type": "object",
                                "properties": {
                                    "end": {
                                        "type": "any"
                                    },
                                    "start": {
                                        "type": "any"
                                    },
                                    "place": {
                                        "type": "Place_Item"
                                    },
                                    "pass": {
                                        "type": "pass_item"
                                    }
                                }
                            }]
                        },
                        "id": {
                            "type": "number"
                        },
                        "date": {
                            "type": "any"
                        }
                    }
                }]
            },
            "map_marker": {
                "type": "object",
                "properties": {
                    "dot": {
                        "type": "string"
                    },
                    "pin": {
                        "type": "string"
                    },
                    "icon": {
                        "type": "string"
                    }
                }
            },
            "image_portrait": {
                "type": "string"
            },
            "collections": {
                "type": "any"
            },
            "id": {
                "type": "number"
            },
            "image_landscape": {
                "type": "string"
            },
            "coordinates": {
                "type": "array",
                "items": [{
                    "type": "coordinates"
                }]
            },
            "duration": {
                "type": "object",
                "properties": {
                    "end_date": {
                        "type": "any"
                    },
                    "start_date": {
                        "type": "any"
                    }
                }
            }
        }
    },
    "weather": {
        "type": "object",
        "properties": {
            "sunset": {
                "type": "any"
            },
            "utcOffset": {
                "type": "number"
            },
            "precipitation": {
                "type": "object",
                "properties": {
                    "hours": {
                        "type": "number"
                    },
                    "probability_mean": {
                        "type": "number"
                    },
                    "sum": {
                        "type": "object",
                        "properties": {
                            "rain": {
                                "type": "number"
                            },
                            "shower": {
                                "type": "number"
                            },
                            "snow": {
                                "type": "number"
                            }
                        }
                    }
                }
            },
            "sunrise": {
                "type": "any"
            },
            "code": {
                "type": "number"
            },
            "temperature": {
                "type": "object",
                "properties": {
                    "unit": {
                        "type": "string"
                    },
                    "average": {
                        "type": "number"
                    },
                    "apparent_max": {
                        "type": "number"
                    },
                    "actual_min": {
                        "type": "number"
                    },
                    "actual_max": {
                        "type": "number"
                    },
                    "apparent_min": {
                        "type": "string"
                    }
                }
            }
        }
    },
    "Any": {
        "type": "any"
    },
    "Function": {
        "type": "Function"
    },
    "Promise": {
        "type": "Promise"
    },
    "Observable": {
        "type": "Observable"
    },
    "Versions": {
        "type": "object",
        "properties": {
            "global_place_list": {
                "type": "number"
            },
            "software": {
                "type": "number"
            },
            "country_region_list": {
                "type": "number"
            }
        }
    },
    "Place_Item": {
        "type": "object",
        "properties": {
            "coordinates": {
                "type": "object",
                "properties": {
                    "longitude": {
                        "type": "number"
                    },
                    "latitude": {
                        "type": "number"
                    }
                }
            },
            "duration": {
                "type": "array",
                "items": [{
                    "type": "number"
                }]
            },
            "category": {
                "type": "number"
            },
            "state_province": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "map_marker": {
                "type": "object",
                "properties": {
                    "icon": {
                        "type": "string"
                    },
                    "pin": {
                        "type": "string"
                    },
                    "dot": {
                        "type": "string"
                    }
                }
            },
            "city": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "description": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "name": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "offer_list": {
                "type": "array",
                "items": [{
                    "type": "any"
                }]
            },
            "_id": {
                "type": "number"
            },
            "na_time": {
                "type": "array",
                "items": [{
                    "type": "object",
                    "properties": {
                        "start": {
                            "type": "any"
                        },
                        "end": {
                            "type": "any"
                        },
                        "day": {
                            "type": "number"
                        }
                    }
                }]
            },
            "safety_index": {
                "type": "number"
            },
            "displayName": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "season_info": {
                "type": "array",
                "items": [{
                    "type": "Season_Factors"
                }]
            },
            "image_portrait": {
                "type": "string"
            },
            "current_weather": {
                "type": "weather"
            },
            "icon": {
                "type": "any"
            },
            "gui_marker": {
                "type": "object",
                "properties": {
                    "color": {
                        "type": "string"
                    },
                    "icon": {
                        "type": "string"
                    }
                }
            },
            "image_landscape": {
                "type": "string"
            },
            "open_time": {
                "type": "array",
                "items": [{
                    "type": "array",
                    "items": [{
                        "type": "array",
                        "items": [{
                            "type": "any"
                        }]
                    }]
                }]
            },
            "overall_score": {
                "type": "number"
            },
            "region": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "image_icon": {
                "type": "string"
            },
            "country": {
                "type": "Country_Info"
            },
            "continent": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            }
        }
    },
    "Place_Search_Criteria": {
        "type": "object",
        "properties": {
            "bottomup_scope": {
                "type": "object",
                "properties": {
                    "coordinates": {
                        "type": "object",
                        "properties": {
                            "longitude": {
                                "type": "number"
                            },
                            "latitude": {
                                "type": "number"
                            }
                        }
                    },
                    "radius": {
                        "type": "number"
                    }
                }
            },
            "topdown_scope": {
                "type": "number"
            },
            "trip_mode": {
                "type": "number"
            },
            "trip_party": {
                "type": "number"
            },
            "place_category": {
                "type": "number"
            },
            "trip_duration": {
                "type": "object",
                "properties": {
                    "start_date": {
                        "type": "any"
                    },
                    "end_date": {
                        "type": "any"
                    }
                }
            }
        }
    },
    "Boolean": {
        "type": "boolean"
    },
    "Event": {
        "type": "object",
        "properties": {
            "score": {
                "type": "number"
            },
            "description": {
                "type": "array",
                "items": [{
                    "type": "string"
                }]
            },
            "date": {
                "type": "string"
            }
        }
    },
    "Select_Place_List": {
        "type": "array",
        "items": [{
            "type": "object",
            "properties": {
                "start": {
                    "type": "any"
                },
                "_id": {
                    "type": "any"
                },
                "end": {
                    "type": "any"
                }
            }
        }]
    },
    "Feed_List": {
        "type": "array",
        "items": [{
            "type": "object",
            "properties": {
                "list": {
                    "type": "array",
                    "items": [{
                        "type": "any"
                    }]
                },
                "category": {
                    "type": "string"
                }
            }
        }]
    },
    "FileReadService": {
        "type": "object",
        "properties": {
            "request": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "formDataFileName": {
                                "type": "string"
                            },
                            "fileInput": {
                                "type": "any"
                            },
                            "filePath": {
                                "type": "string"
                            },
                            "blobType": {
                                "type": "string"
                            },
                            "resultFormat": {
                                "type": "string",
                                "default": "FORM_DATA"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "data": {
                                "type": "any"
                            }
                        }
                    }
                }
            }
        }
    },
    "FileReadService_Profile": {
        "type": "object",
        "properties": {
            "request": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "formDataFileName": {
                                "type": "string"
                            },
                            "blobType": {
                                "type": "string"
                            },
                            "filePath": {
                                "type": "string"
                            },
                            "fileInput": {
                                "type": "any"
                            },
                            "resultFormat": {
                                "type": "string",
                                "default": "FORM_DATA"
                            }
                        }
                    }
                }
            },
            "response": {
                "type": "object",
                "properties": {
                    "data": {
                        "type": "object",
                        "properties": {
                            "data": {
                                "type": "any"
                            }
                        }
                    }
                }
            }
        }
    }
};
/**
 * Data storage
 */
export const _aioDefStorageValues = {
    variables: {
    },
    storages: {
        "CurrentVersions": {
            software: 20230101,
            country_region_list: 0,
            global_place_list: 0
        }
    },
    functions: {
    }
}